module.exports = __webpack_public_path__ + "b8a208aaf7f2716056ffaea521546f36.png";